module.exports = __webpack_public_path__ + "static/media/hong-kong.6738eacd.png";